export const TEMPORARY_USER_EMAIL = 'pleaseenteryouremailaddress@buzzbingo.com';
